import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;
const cache = new Map();
const TTL = 60_000;

async function get(path, params = {}) {
  const key = path + JSON.stringify(params);
  const cached = cache.get(key);
  if (cached && Date.now() - cached.ts < TTL) return cached.data;
  const res = await axios.get(`${BASE}${path}`, { params });
  cache.set(key, { data: res.data, ts: Date.now() });
  return res.data;
}

function invalidate(pathPrefix) {
  for (const key of cache.keys()) {
    if (key.startsWith(pathPrefix)) cache.delete(key);
  }
}

const api = { get, invalidate, BASE };
export default api;
